<template>
  <div
    class="speakers _bg-light _py-10 _px-8 _py-sm-8 _px-sm-4"
    v-if="speakers && speakers.length"
  >
    <div class="speakers__title _fs-24 _lh-32 _tc-dark-grey _mb-8">
      {{ $t('pages.intensive_detail.speakers') }}
    </div>
    <div class="speakers__list">
      <div class="speaker" v-for="(speaker, ind) in speakers" :key="ind">
        <div class="speaker__image-container _mr-4">
          <img class="speaker__image" :src="speaker.avatar" />
        </div>
        <div class="speaker__text _my-auto">
          <div
            class="speaker__name _fs-20 _fs-sm-16 _lh-24 _tc-dark _mb-1 _fw-700"
          >
            {{ getTranslate(speaker).name }}
          </div>
          <div
            class="speaker__position _fs-16 _lh-24 _tc-dark-grey _fw-400"
            v-html="getTranslate(speaker).description"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Speakers',
  props: {
    speakers: Array,
  },
  methods: {
    getTranslate(item) {
      return item.translates[0]
    },
  },
}
</script>

<style lang="scss" scoped>
.speakers {
  border-radius: 16px;

  &__list {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 32px;

    @media screen and (max-width: 743px) {
      grid-template-columns: 1fr;
    }
  }
}

.speaker {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;

  &__image-container {
    width: 78px;
    height: 78px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
  }

  &__image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
}
</style>
